// extracted by css-extract-rspack-plugin
var _1 = "form__OJK_B";
var _2 = "label__BGoBD";
var _3 = "submit__D517z";
var _4 = "subscribe__UzN50";
var _5 = "subscribe__text__xlElO";
var _6 = "terms__bgDtt";
export { _1 as "form", _2 as "label", _3 as "submit", _4 as "subscribe", _5 as "subscribe__text", _6 as "terms" }
export default { "form": _1, "label": _2, "submit": _3, "subscribe": _4, "subscribe__text": _5, "terms": _6 }
